import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { STORAGE_TOKEN } from "constants/common/common";
import { LoginData } from "constants/types/auth";
import { UserRoles } from "constants/types/user";
import { PermissionCode } from "constants/types/permission";

const checkToken = (): boolean => {
  const tokenString = localStorage.getItem(STORAGE_TOKEN);
  const tokenData = JSON.parse(tokenString!);
  const accessToken = tokenData?.access_token!;
  return accessToken ? true : false;
};

interface AuthState {
  isLoggedIn: boolean;
  isSessionLoading: boolean;
  roles: UserRoles[];
  permissions: PermissionCode[];
}

const initialState: AuthState = {
  isLoggedIn: checkToken(),
  isSessionLoading: checkToken(),
  roles: [],
  permissions: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state: AuthState, action: PayloadAction<LoginData>) => {
      return state;
    },
    logout: (state: AuthState) => {
      return state;
    },
    checkSession: (state: AuthState) => {
      return state;
    },
    updateState: (state: AuthState, action: PayloadAction<any>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { login, logout, checkSession, updateState } = authSlice.actions;

export default authSlice.reducer;
